import React, { Component } from 'react';
import moment from 'moment';
import EventWinnerViewer from './EventWinnerViewer';
import DesktopLayerPopup from '../../../common/DesktopLayerPopup';
import { Switch, Case, Default } from '../../../../library/ReactSwitchCase';

class EventWinnerViewButton extends Component {
  constructor(props) {
    super(props);

    this.onClickWinnerView = this.onClickWinnerView.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onShare = this.onShare.bind(this);
  }

  onClose() {
    DesktopLayerPopup.hide(this.winnerView);
  }

  onClickWinnerView(e) {
    e.preventDefault();
    const { postInfo } = this.props;
    this.winnerView = DesktopLayerPopup.modal(
      <EventWinnerViewer
        {...this.props}
        postId={postInfo.id}
        onClose={this.onClose}
      />
    );
    // 로그인 안했을 경우 로그인 팝업 출력 - 추후 추가
  }

  onShare(e) {
    e.preventDefault();
    DesktopLayerPopup.clipBoard({ url: window.location.href });
  }

  render() {
    const { postInfo } = this.props;
    const condition = this.props.postMoreList ? true : false;
    const showButton = postInfo.data
      ? postInfo.child_count > 0 &&
        moment().isAfter(postInfo.data.event_info.end_date)
      : false;
    if (showButton === false) {
      return null;
    }
    return (
      <Switch condition={condition}>
        <Case value={true}>
          <a href="#" className="go" onClick={this.onClickWinnerView}>
            당첨자 발표 보기
          </a>
        </Case>
        <Default>
          <div className="right">
            <a
              href="#"
              className="btn-type2 give-box on"
              onClick={this.onClickWinnerView}
            >
              당첨자 발표 보기
            </a>
            &nbsp;
            {this.props.type && this.props.type === 'detail' && (
              <a href="#" className="share" onClick={this.onShare}>
                공유하기
              </a>
            )}
          </div>
        </Default>
      </Switch>
    );
  }
}

export default EventWinnerViewButton;
